<template>
  <div v-if="isEmpty" class="header-configs header-configs-empty pa-5">
    <h2 class="ma-0 mb-4">Produtos em análise</h2>
    <p class="description ma-0 mb-4">Selecione os produtos abaixo para realizar a análise e visualizar a estratégia de impulsionamento.</p>
    <p class="description ma-0 mb-5">Você também pode selecionar um produto direto da lista abaixo, com sugestões de produtos com maior ganho potencial.</p>
    <div class="d-flex justify-center">
      <modal-graphql-search-content
        :selected-items.sync="selectedProducts"
        button-activator
        hide-csv-upload
        button-text="Selecionar produtos"
        @confirm="insertProducts"
      />
    </div>
  </div>

  <div v-else class="header-configs">
    <div class="d-flex justify-space-between">
      <h2 class="ma-0 mr-2 mb-4">{{ title }}</h2>
      <modal-graphql-search-content
        :selected-items.sync="selectedProducts"
        button-activator
        hide-csv-upload
        button-text="Alterar produtos"
        @confirm="insertProducts"
      />
    </div>
    <p class="description ma-0 mb-5">
      Os produtos abaixo foram identificados com o maior potencial de recuperação nessa semana. Você pode ainda incluir ou alterar os produtos em análise.
    </p>

    <div class="filters d-flex align-stretch">
      <div class="units">
        <label>Lojas</label>
        <div class="d-flex align-start">
          <mf-select-units-dialog
            :selected-units.sync="filterUnits"
            hide-ecommerce-configuration
            show-units-count
            template-type="button"
            btn-content="Filtrar lojas"
            check-all-units-on-init
            :units="units"
            :tag-list="tagList"
            :group-list="unitsGroups"
          />
          <mf-tooltip variant="secondary" top max-width="370">
            <template v-slot:activator>
              <mf-button icon="category" label="Grupos" text color="marca-0-l40" class="unset-capitalize ml-2" @click="redirectToGroups" />
            </template>
            Agora suas lojas podem ser agrupadas de acordo com a precificação. Clique aqui para configurar esses grupos.
          </mf-tooltip>
        </div>
      </div>

      <div class="dates d-flex align-center">
        <div class="mx-3">
          <label>Período Referência</label>
          <mf-date-range-picker
            outlined
            icon
            show-days-counter
            dense
            :initial-date="filterReferenceDate[0]"
            :final-date="filterReferenceDate[1]"
            @input="filterReferenceDate = $event"
          />
        </div>
        <div>
          <label>Período Atual</label>
          <mf-date-range-picker
            outlined
            icon
            show-days-counter
            dense
            :initial-date="filterCurrentDate[0]"
            :final-date="filterCurrentDate[1]"
            @input="filterCurrentDate = $event"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { produtosImpulsionadores } from '../../../mixins/produtos-impulsionadores'
import { mapGetters } from 'vuex'
export default {
  name: 'HeaderConfigs',
  components: {
    ModalGraphqlSearchContent: () => import('@/components/ModalGraphqlSearchContent.vue'),
  },
  mixins: [produtosImpulsionadores],
  data: () => ({
    search: '',
  }),
  computed: {
    ...mapGetters(['units', 'tagList', 'unitsGroups']),
    selectedProducts: {
      get() {
        return this.opportunities.selectedProducts
      },
      set(value) {
        this.SET_OPPORTUNITIES_KEY({ key: 'selectedProducts', payload: value })
      },
    },
    filterUnits: {
      get() {
        return this.opportunities.filters.units
      },
      set(value) {
        const newFilters = {
          ...this.opportunities.filters,
          units: value,
        }
        this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: newFilters })
      },
    },
    filterReferenceDate: {
      get() {
        return this.opportunities.filters.referenceDate
      },
      set(value) {
        const newFilters = {
          ...this.opportunities.filters,
          referenceDate: value,
        }
        this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: newFilters })
      },
    },
    filterCurrentDate: {
      get() {
        return this.opportunities.filters.currentDate
      },
      set(value) {
        const newFilters = {
          ...this.opportunities.filters,
          currentDate: value,
        }
        this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: newFilters })
      },
    },
    isEmpty() {
      return this.opportunities.filters.products < 1
    },
    title() {
      const size = this.opportunities?.filters?.products?.length
      return size !== 1 ? `${size} produtos em análise` : '1 produto em análise'
    },
  },
  methods: {
    redirectToGroups() {
      const routePath = '/configuracoes/units'
      const url = window.location.origin + this.$router.resolve(routePath).href

      window.open(url, '_blank')
    },
    insertProducts(productsAndGroups) {
      const products = productsAndGroups.map((item) => {
        return {
          ...item,
          isSelectedItem: true,
        }
      })
      this.SET_OPPORTUNITIES_KEY({ key: 'selectedProducts', payload: products })

      const filters = {
        ...this.opportunities.filters,
        products: [...this.opportunities.suggestedProducts, ...this.opportunities.selectedProducts],
      }
      this.SET_OPPORTUNITIES_KEY({ key: 'filters', payload: filters })
    },
  },
}
</script>

<style lang="scss" scoped>
.header-configs-empty {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4' ry='4' stroke='%23A5ACB4FF' stroke-width='1' stroke-dasharray='10' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  border-radius: 4px;
}
.header-configs {
  h2 {
    color: $cinza-d20;
    font-weight: bold;
    font-size: 26px;
    line-height: 120%;
  }

  .description {
    color: $cinza-0;
    font-size: 14px;
    line-height: 20px;
  }

  .filters {
    label {
      display: block;
      margin-bottom: 8px;
      color: $cinza-d10;
      font-weight: bold;
      line-height: 20px;
      font-size: 14px;
    }

    .units {
      padding-right: 8px;
      border-right: 1px solid $cinza-l50;
    }
  }
}
</style>
